import { useEffect, useState } from 'react'

const G = '#C89B4C'
const BD = 'rgba(244,238,225,0.14)'
const S = 'linear-gradient(155deg, rgba(255,248,235,0.05) 0%, rgba(255,248,235,0.015) 100%)'
const TX = '#F4F1EA'
const TX3 = '#8A8480'
const MONO = "'JetBrains Mono', monospace"

const PRESETS = [1, 3, 6, 9, 12, 18, 24]
export const MIN_TERM = 1

/** Installment term picker: quick presets plus a free-form number of months (MIN_TERM..max). */
export default function TermPicker({ value, onChange, max, lang }: {
  value: number
  onChange: (m: number) => void
  max: number
  lang: string
}) {
  const [text, setText] = useState(String(value))
  useEffect(() => setText(String(value)), [value])

  const handleInput = (raw: string) => {
    setText(raw)
    const n = parseInt(raw, 10)
    if (n >= MIN_TERM && n <= max) onChange(n)
  }

  return (
    <div>
      <div style={{ display: 'flex', gap: 6, marginBottom: 10 }}>
        {PRESETS.filter(m => m <= max).map(m => (
          <button
            key={m}
            onClick={() => onChange(m)}
            style={{
              flex: 1, padding: '10px 0', textAlign: 'center', borderRadius: 10,
              fontFamily: MONO, fontSize: 13,
              background: m === value ? G : S,
              color: m === value ? '#0D1526' : TX3,
              border: m === value ? 'none' : `1px solid ${BD}`,
              cursor: 'pointer', fontWeight: m === value ? 600 : 400,
            }}
          >
            {m}
          </button>
        ))}
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <span style={{ fontSize: 12, color: TX3, flex: 1 }}>
          {lang === 'uz' ? `Boshqa muddat (${MIN_TERM}–${max} oy)` : `Другой срок (${MIN_TERM}–${max} мес.)`}
        </span>
        <input
          type="number" inputMode="numeric" min={MIN_TERM} max={max} step={1}
          value={text}
          onChange={e => handleInput(e.target.value)}
          onBlur={() => setText(String(value))}
          style={{
            width: 84, padding: '8px 12px', borderRadius: 10, textAlign: 'center',
            background: S, border: `1px solid ${BD}`, color: TX,
            fontFamily: MONO, fontSize: 14, outline: 'none',
          }}
        />
      </div>
    </div>
  )
}
